import { Button, Popconfirm, Space, Switch, Table, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useKycQuestionnaires } from "./useKycQuestionnaires";
import { useCanEdit } from "@/hooks/usePermission";

export const KycQuestionnaireListWidget = () => {
  const {
    data,
    loading,
    page,
    setPage,
    deleteKycQuestionnaire,
    toggleActive,
  } = useKycQuestionnaires();
  const canEdit = useCanEdit("kyc-questionnaire");

  return (
    <>
      <div className="page-header">
        <h3>KYC Судалгааны жагсаалт</h3>
        {canEdit && (
          <Space>
            <Link to="/kyc-questionnaires/create">
              <Button type="primary" icon={<PlusOutlined />}>
                Судалгаа нэмэх
              </Button>
            </Link>
          </Space>
        )}
      </div>
      <div className="page-body">
        <div className="page-table">
          <Table
            scroll={{ x: 900 }}
            dataSource={data?.questionnaires ?? []}
            size="small"
            loading={loading}
            rowKey="_id"
            bordered
            pagination={{
              current: page + 1,
              total: (data?.totalPages ?? 0) * 20,
              pageSize: 20,
              onChange: (p) => setPage(p - 1),
            }}
            columns={[
              {
                title: "Нэр",
                dataIndex: "name",
                key: "name",
              },
              {
                title: "Идэвхитэй",
                dataIndex: "active",
                key: "active",
                width: 100,
                render: (active: boolean, record) => (
                  <Switch
                    checked={active}
                    loading={loading}
                    checkedChildren="Идэвхтэй"
                    unCheckedChildren="Идэвхгүй"
                    onChange={(checked) => {
                      if (record._id) toggleActive(record._id, checked);
                    }}
                  />
                ),
              },
              {
                title: "Асуултын тоо",
                key: "questionCount",
                width: 120,
                render: (_, record) => record.questions?.length ?? 0,
              },
              {
                title: "Үүсгэсэн",
                dataIndex: "createdAt",
                key: "createdAt",
                width: 180,
                render: (val: number) =>
                  val ? new Date(val).toLocaleDateString("mn-MN") : "-",
              },
              {
                title: "",
                key: "actions",
                fixed: "right",
                width: 200,
                render: (_, record) => (
                  <Space>
                    <Link to={`/kyc-questionnaires/detail/${record._id}`}>
                      <Button
                        type="primary"
                        shape="circle"
                        icon={<EyeOutlined />}
                      />
                    </Link>
                    {canEdit && (
                      <>
                        <Link to={`/kyc-questionnaires/edit/${record._id}`}>
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<EditOutlined />}
                          />
                        </Link>
                        {record.active ? (
                          <Link to={`/kyc-questionnaires/send/${record._id}`}>
                            <Button shape="circle" icon={<SendOutlined />} />
                          </Link>
                        ) : (
                          <Tooltip title="Идэвхгүй KYC судалгааг илгээх боломжгүй">
                            <Button
                              shape="circle"
                              icon={<SendOutlined />}
                              disabled
                            />
                          </Tooltip>
                        )}
                        <Popconfirm
                          disabled={loading}
                          title="Та устгахдаа итгэлтэй байна уу?"
                          okText="Тийм"
                          cancelText="Үгүй"
                          onConfirm={() => {
                            if (record._id) {
                              deleteKycQuestionnaire(record._id);
                            }
                          }}
                        >
                          <Button
                            shape="circle"
                            disabled={loading}
                            danger
                            type="primary"
                            icon={<DeleteOutlined />}
                          />
                        </Popconfirm>
                      </>
                    )}
                  </Space>
                ),
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};
